import { render, staticRenderFns } from "./AscErrorTypeLabel.vue?vue&type=template&id=470166c5&"
import script from "./AscErrorTypeLabel.vue?vue&type=script&lang=js&"
export * from "./AscErrorTypeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports